
export default 
{

    items: [
        {
            id: 'Reports',
            title: 'Reports',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'TopReports',
                    title: 'Reports',
                    type: 'item',
                    url: '/Reports',
                    icon: 'feather icon-arrow-up',
                },
                
            ]
        },
                {
            id: 'ui-element',
            title: 'Users',
            type: 'group',
            icon: 'icon-ui',
            children: [
                {
                    id: 'basic',
                    title: 'Captains',
                    type: 'collapse',
                    icon: 'feather icon-user',
                    children: [
                        {
                            id: 'Addtime',
                            title: 'Add Schedule (اضافه معاد)',
                            type: 'item',
                            url: '/AddCaptainSchedule'
                        },
                        {
                            id: 'Schedule',
                            title: 'Captains Schedule (الجداول)',
                            type: 'item',
                            url: '/CaptainsTable'
                        },
                        
                    ]
                }
            ]
        },
        
        {
            id: 'ui-element',
            title: 'Users',
            type: 'group',
            icon: 'icon-ui',
            children: [
                {
                    id: 'basic',
                    title: 'Users',
                    type: 'collapse',
                    icon: 'feather icon-user',
                    children: [
                        {
                            id: 'AddUSers',
                            title: 'Add Users',
                            type: 'item',
                            url: '/Signup'
                        },
                        {
                            id: 'ManageUsers',
                            title: 'Manage Users',
                            type: 'item',
                            url: '/ManageUsers'
                        },
                        
                    ]
                }
            ]
        },
        {
            id: 'ui-forms',
            title: 'Sales',
            type: 'group',
            icon: 'icon-group',
            children: [
                {
                    id: 'Leads',
                    title: 'Leads',
                    type: 'collapse',
                    icon: 'feather icon-menu',
                    children: [
                        // {
                        //     id: 'SearchEmployee',
                        //     title: 'Search Leads',
                        //     type: 'item',
                        //     url: '/SearchLeads',
                        // },
                        {
                            id: 'AddLeads',
                            title: 'Add Leads',
                            type: 'item',
                            url: '/AddLeads',
                        },
                        {
                            id: 'TopLeads',
                            title: 'Top Leads',
                            type: 'item',
                            url: '/TopLeads',
                        },
                        {
                            id: 'AllLeads',
                            title: 'All Leads',
                            type: 'item',
                            url: '/AllLeads',
                        },
                    ]
                },
            ]
        },
        {
            id: 'Reception',
            title: 'Reception',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'Attendance',
                    title: 'Attendance',
                    type: 'item',
                    url: '/AttendanceSearch',
                    icon: 'feather icon-arrow-up',
                },
                
            ]
        },
    ]
}